module.exports = __webpack_public_path__ + "assets/img/3-1.7d9bef22.png";